// import axios from 'axios';
// // config
// import { HOST_API_KEY } from '../config-global';

// // ----------------------------------------------------------------------

// const axiosInstance = axios.create({ baseURL: HOST_API_KEY });
// let refreshRequest = null;

// const clearAuthentication = () => {
//   localStorage.removeItem('accessToken');
//   localStorage.removeItem('refreshToken');
//   localStorage.removeItem('user');
//   delete axiosInstance.defaults.headers.common.Authorization;
// };

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     const refreshToken = localStorage.getItem('refreshToken');
//     const isRefreshRequest = originalRequest?.url?.includes('/authw/refresh-tokens');

//     if (error.response?.status === 401 && refreshToken && !originalRequest?._retry && !isRefreshRequest) {
//       originalRequest._retry = true;
//       try {
//         if (!refreshRequest) {
//           refreshRequest = axios.post(`${process.env.REACT_APP_BACKEND_URL}/authw/refresh-tokens`, {
//             refreshToken,
//             browserInfo: { userAgent: window.navigator.userAgent },
//           }).finally(() => {
//             refreshRequest = null;
//           });
//         }
//         const response = await refreshRequest;
//         const tokens = response.data?.tokens || response.data;
//         const accessToken = tokens?.access?.token;
//         const nextRefreshToken = tokens?.refresh?.token;
//         if (!accessToken || !nextRefreshToken) throw new Error('Invalid refresh response');

//         localStorage.setItem('accessToken', accessToken);
//         localStorage.setItem('refreshToken', nextRefreshToken);
//         axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//         originalRequest.headers = originalRequest.headers || {};
//         originalRequest.headers.Authorization = `Bearer ${accessToken}`;
//         return axiosInstance(originalRequest);
//       } catch (refreshError) {
//         clearAuthentication();
//         window.location.assign('/auth/login');
//         return Promise.reject(refreshError?.response?.data || refreshError);
//       }
//     }

//     if (error.response?.status === 401) {
//       clearAuthentication();
//       window.location.assign('/auth/login');
//     }

//     return Promise.reject((error.response && error.response.data) || error || 'Something went wrong');
//   }
// );

// export default axiosInstance;

// // ----------------------------------------------------------------------
// // V2 API INSTANCE
// // ----------------------------------------------------------------------

// export const axiosV2 = axios.create({
//   baseURL: process.env.REACT_APP_BACKEND_URL_V2,
// });

// axiosV2.interceptors.request.use(
//   (config) => {
//     const token =
//       sessionStorage.getItem('accessToken') ||
//       localStorage.getItem('accessToken');

//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// axiosV2.interceptors.response.use(
//   (response) => response,
//   handleUnauthorized(axiosV2)
// );

import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';
// auth
import { isImpersonationToken, setSession, setRefresh, setWarehouseSelection } from '../auth/utils';
import { gatherBrowserInfo, getAuthBrowserInfo } from './gatherBrowserInfo';

// ----------------------------------------------------------------------

export const WAREHOUSE_AUTH_V2 = '/warehouse/staff/auth';

// Impersonation sessions are issued by the V1 exchange and are rejected by the V2 staff endpoints.
const IMPERSONATION_REFRESH_URL = `${process.env.REACT_APP_BACKEND_URL}/authw/refresh-tokens`;
const REFRESH_URL = `${process.env.REACT_APP_BACKEND_URL_V2}${WAREHOUSE_AUTH_V2}/refresh-tokens`;

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });
let refreshRequest = null;

const clearAuthentication = () => {
  setSession(null);
  setRefresh(null);
  setWarehouseSelection(null);
};

const requestTokenRefresh = async (refreshToken) => {
  if (isImpersonationToken(refreshToken)) {
    return axios.post(IMPERSONATION_REFRESH_URL, {
      refreshToken,
      browserInfo: { userAgent: window.navigator.userAgent },
    });
  }
  const browserInfo = getAuthBrowserInfo(await gatherBrowserInfo());
  return axios.post(REFRESH_URL, { refreshToken, browserInfo: { browser: browserInfo.browser } });
};

const handleUnauthorized = (client) => async (error) => {
  const originalRequest = error.config;
  const refreshToken = localStorage.getItem('refreshToken');
  const isRefreshRequest = originalRequest?.url?.includes('/refresh-tokens');

  if (error.response?.status === 401 && refreshToken && !originalRequest?._retry && !isRefreshRequest) {
    originalRequest._retry = true;
    try {
      if (!refreshRequest) {
        refreshRequest = requestTokenRefresh(refreshToken).finally(() => {
          refreshRequest = null;
        });
      }
      const response = await refreshRequest;
      const tokens = response.data?.tokens || response.data;
      const accessToken = tokens?.access?.token;
      const nextRefreshToken = tokens?.refresh?.token;
      if (!accessToken || !nextRefreshToken) throw new Error('Invalid refresh response');

      setSession(accessToken);
      setRefresh(nextRefreshToken);
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer ${accessToken}`;
      return client(originalRequest);
    } catch (refreshError) {
      clearAuthentication();
      window.location.assign('/auth/login');
      return Promise.reject(refreshError?.response?.data || refreshError);
    }
  }

  if (error.response?.status === 401) {
    clearAuthentication();
    window.location.assign('/auth/login');
  }

  return Promise.reject((error.response && error.response.data) || error || 'Something went wrong');
};

axiosInstance.interceptors.response.use(
  (response) => response,
  handleUnauthorized(axiosInstance)
);

// ----------------------------------------------------------------------
// V2 API INSTANCE
// ----------------------------------------------------------------------

export const axiosV2 = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL_V2,
});

axiosV2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosV2.interceptors.response.use(
  (response) => response,
  handleUnauthorized(axiosV2)
);

export default axiosInstance;
